
import createValidatePropsMethod from './../lib/createValidatePropsMethod'
import { validateFile } from './../files/actions'

/**
 * Checks that the branch is a valid object and doesn't have invalid props.
 * Will throw if it does
 * @param {object} repository
 */
const validateBranch = createValidatePropsMethod({
  'id': `Missing prop on branch 'id'.`,
  'repositoryId': `Missing prop on branch 'repositoryId'.`,
  'name': `Missing prop on branch 'name'.`,
})


/**
 * Add a branch
 * @param {object} branch Expects props id, name and 'repositoryId'
 */
export function addBranch(branch){
  validateBranch(branch)
  return {
    type: 'ADD_BRANCH',
    payload: { branch }
  }
}

/**
 * Load the schema file for a branch
 * @param {string} branchId
 */
export function loadSchema(branchId){
  return {
    type: 'LOAD_SCHEMA',
    payload: { branchId }
  }
}


/**
 * Saves the files to the branch
 * @param {string} branchId
 * @param {Array<object>} files
 * @param {string} commitMessage
 */
export function saveFiles(branchId, files, commitMessage){
  if (!branchId)
    throw new Error(`Invalid 'branchId' ${branchId}.`)
  if (!(files instanceof Array))
    throw new Error(`Expected 'files' to be an array.`)
  if (typeof commitMessage != 'string')
    throw new Error(`Invalid 'commitMessage' ${commitMessage}. Expected a string.`)

  // Check all files belong to the branch
  files.forEach(file => validateFile(file))

  return {
    type: 'SAVE_FILES',
    payload: {
      branchId,
      commitMessage,
      files,
    }
  }
}

/**
 * Creates a branch and saves the files to the branch
 * @param {string} currentBranchId
 * @param {string} newBranchName
 * @param {Array<object>} files
 * @param {string} commitMessage
 * @param {string} repositoryId
 */
export function createBranchAndSaveFiles(currentBranchId, newBranchName, files, commitMessage, repositoryId){
  if (!currentBranchId)
    throw new Error(`Missing parameter 'currentBranchId'.`)
  if (!newBranchName)
    throw new Error(`Missing parameter 'newBranchName'.`)
  if (!(files instanceof Array))
    throw new Error(`Expected 'files' to be an array.`)
  if (typeof commitMessage != 'string')
    throw new Error(`Invalid 'commitMessage' ${commitMessage}. Expected a string.`)
  if (!repositoryId)
    throw new Error(`Missing parameter 'repositoryId'.`)

  // Check all files belong to the branch
  /*files.forEach(file => {
    validateFile(file)
    if (file.branchId != currentBranchId)
      throw new Error(`File does not belong to branch.`)
  })*/

  return {
    type: 'CREATE_BRANCH_AND_SAVE_FILES',
    payload: {
      currentBranchId,
      newBranchName,
      commitMessage,
      files,
      repositoryId,
    }
  }
}

/**
 * Creates a branch off the current branch and moves uncommitted files to the
 * new branch.
 * @param {string} currentBranchId
 * @param {string} newBranchName
 * @param {string} repositoryId
 * @returns {object}
 */
export function createBranch(currentBranchId, newBranchName, repositoryId){
  if (!currentBranchId)
    throw new Error(`Missing parameter 'currentBranchId'.`)
  if (!newBranchName)
    throw new Error(`Missing parameter 'newBranchName'.`)
  if (!repositoryId)
    throw new Error(`Missing parameter 'repositoryId'.`)
  return {
    type: 'CREATE_BRANCH',
    payload: {
      currentBranchId,
      newBranchName,
      repositoryId
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/branches/actions.js